import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import style from "./style";
import React from "react";

const FacilityPanel = ({facility}) => (
  <Card>
    <CardHeader
      style={style.cardHeader}
      title={`${facility.name}, ${facility.short_name}`}
      subheader={facility.address}
    />
  </Card>
);

export default FacilityPanel;



// WEBPACK FOOTER //
// ./src/pages/Map/FacilityPanel.jsx